import React, { useEffect, useLayoutEffect } from 'react'
import ConnectedPageSearchContainer from 'redux/containers/pages/search/ConnectedPageSearchContainer'

const Paged = (props) => {
  const {
    searchPhrase,
    setCurrentSearchPhrase,
    searchType,
    pageNumber,
    pageLimit,
    query,
    setSearchState,
    setSearchResponse
  } = props

  useLayoutEffect(() => {
    setSearchState({ pageLimit, pageNumber, paginationMode: 'paged', query, searchPhrase, searchType })
  }, [pageLimit, pageNumber, query, searchPhrase, searchType, setSearchState])

  useEffect(() => {
    return () => {
      setSearchResponse(null)
      setCurrentSearchPhrase('')
    }
  }, [])

  return <ConnectedPageSearchContainer />
}

export default Paged
